import React from 'react';

import {
  DropdownBase,
  DropdownNesting,
  DropdownFilter,
  DropdownTrigger,
  DropdownMultiselect,
  MenuButton
} from './exports';

const AdvancedDropdown = () => <> Deprecated </>;

AdvancedDropdown.displayName = 'Advanced Dropdown';
AdvancedDropdown.propTypes = {};

export {
  DropdownBase,
  DropdownNesting,
  DropdownFilter,
  DropdownTrigger,
  DropdownMultiselect,
  MenuButton
};
export default AdvancedDropdown;
